<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 138.7 104">
    <rect width="138.7" height="104" rx="14.4" ry="14.4" fill="#f26522" />
    <path
      fill="#fff"
      d="M81.2,40.6c4.2,0,7.9-3.2,7.9-7.8h0c0-4.6-3.6-7.8-7.9-7.8s-7.9,3.2-7.9,7.8,3.6,7.8,7.9,7.8ZM91.5,53.2c-5.2,6.8-10.8,11.5-20.6,11.5h0c-10,0-17.7-6-23.8-14.9-2.4-3.6-6.2-4.4-8.9-2.5-2.5,1.8-3.1,5.6-.8,8.9,8.4,12.8,20,20.2,33.5,20.2s22.1-6,29.6-16.1c2.8-3.7,2.7-7.5,0-9.6-2.5-2-6.2-1.3-9.1,2.4Z"
    />
  </svg>
</template>
